import routeName from '../constant';
import { guideRoutes } from '@/utils/guideRoutes';

const routes = [
    {
        path: 'withdraw-policy-terms',
        name: routeName.WITHDRAW_POLICY_TERMS,
        component: () => import('@/views/aplCatl640and631/AE/landingPage/Index.vue'),
        meta: { auth: true, metaTitle: '減少保單帳戶價值準備金說明', leaveAlert: true, code: 'AE', unableBack: true },
    },
    {
        path: 'withdraw-policy',
        name: routeName.WITHDRAW_POLICY,
        component: () => import('@/views/aplCatl640and631/AE/withdrawPolicy/Index.vue'),
        meta: { auth: false, metaTitle: '減少保單帳戶價值準備金', leaveAlert: true, code: 'AE', unableBack: true },
        beforeEnter: (to, from, next) => {
            const whiteList = [routeName.WITHDRAW_POLICY_TERMS, routeName.CONFIRM_DATA];
            const guideRoute = guideRoutes(from, whiteList, true);
            next(guideRoute);
        },
    }
];

export default routes;
